// Originally auto-generated. Hand-modified to read config from env vars instead of
// hardcoded values, so each deploy context (prod / dev branch / preview) targets its
// own Supabase project. If tooling regenerates this file, RE-APPLY the env-driven block
// below — do not let it revert to a hardcoded URL/key.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Fail fast: a missing var must error loudly, never silently fall back to production.
if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "Missing Supabase config: set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY " +
    "(per Netlify deploy context, or in .env for local dev).",
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Safari can drop the apikey header on cross-origin requests in certain conditions.
// This custom fetch wrapper ensures the header is always present.
const safeFetch: typeof fetch = (input, init) => {
  const headers = new Headers(init?.headers);
  if (!headers.has('apikey')) {
    headers.set('apikey', SUPABASE_PUBLISHABLE_KEY);
  }
  return fetch(input, { ...init, headers });
};

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: safeFetch,
  },
});